import React from 'react'

import { EndUserPropertySource } from 'modules/accountActivity/domain'

export interface SalesforceContactAttribute {
  displayName: string
  name: string
  enabled: boolean
  source: EndUserPropertySource
  type: string
  displayIndex: number
}

export const SalesforceContext = React.createContext<SalesforceContactAttribute[]>([])
